import { useMemo } from 'react'
import { getCodeSetLabelLookup } from '../../../Functions/CodeSetFns'
import { useUserContext } from '../../../Contexts/UserConfig'
import { GridColDef } from '@mui/x-data-grid-pro'

export function useScreenReportCols(manifest: boolean) {
  const { loginConfig } = useUserContext()
  return useMemo(() => {
    let statusCol: GridColDef[] = []
    if (!manifest) {
      statusCol = [
        {
          flex: 1,
          headerName: 'Status',
          field: 'Status',
          valueFormatter: (value: any) =>
            getCodeSetLabelLookup(loginConfig, ['SampleStatusID'], value),
        },
      ]
    }

    return [
      {
        flex: 1,
        headerName: 'Screen ID',
        field: 'ScreenID',
        hide: true,
      },
      {
        flex: 1,
        headerName: 'Recipient Lab',
        field: 'DestinationFacilityID',
        valueFormatter: (value: any) =>
          getCodeSetLabelLookup(loginConfig, ['KV-Facilities'], value),
      },
      {
        flex: 1,
        headerName: 'Final Sample ID',
        field: 'FinalSampleID',
      },
      {
        flex: 1,
        headerName: 'Sample Type',
        field: 'RunType',
        valueFormatter: (value: any) =>
          getCodeSetLabelLookup(loginConfig, ['SampleRunTypeID'], value),
      },
      {
        flex: 2,
        headerName: 'Tests',
        field: 'Tests',
      },
      {
        flex: 1.5,
        headerName: 'Holding',
        field: 'OriginHoldingID',
        valueFormatter: (value: any) =>
          getCodeSetLabelLookup(loginConfig, ['KV-Holdings'], value),
      },
      ...statusCol,
    ]
  }, [loginConfig, manifest])
}
